import { useState, useCallback } from 'react';
import AttestatoSpedizioneService from '../services/AttestatoSpedizioneService/AttestatoSpedizioneService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useAttestatoSpedizione = () => {
    const [isLoading, setIsLoading] = useState(false);

    // --- FUNZIONE CORRETTA COME 'async' ---
    const saveSpedizione = useCallback(async (formData) => {
        setIsLoading(true);
        try {
            // Usiamo 'await' per attendere il completamento della chiamata al servizio
            await AttestatoSpedizioneService.saveSpedizione(formData);
            alertService.success("Dati di spedizione salvati con successo!", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {
        isLoading,
        saveSpedizione
    };
};

export default useAttestatoSpedizione;